let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6lkCp")).then(() => parcelRequire('hJ5cE'));